import {
    faFile,
    faFolder,
    faBrain,
    faPaperclip,
    faFileAudio,
    faFileCsv,
    faFileExcel,
    faSquare,
    faFileWord,
    faFileCode,
    faFileImage,
    faFilePowerpoint,
    faVideo,
    faPager,
    faFilePdf,
    faFileLines,
    faFileZipper,
} from "@fortawesome/free-solid-svg-icons";

export const iconMapping = {
    "folder": { icon: faFolder, color: "#f1c40f" }, // yellow
    "ai": { icon: faBrain, color: "#a569bd" }, // purple
    "attachment": { icon: faPaperclip, color: "#7f8c8d" }, // grey
    "audio": { icon: faFileAudio, color: "#1abc9c" }, // teal
    "csv": { icon: faFileCsv, color: "#e67e22" }, // orange
    "eps": { icon: faFile, color: "#34495e" }, // dark gray
    "excel": { icon: faFileExcel, color: "green" },
    "exe": { icon: faFile, color: "#2c3e50" },
    "flash": { icon: faSquare, color: "#f39c12" },
    "gdoc": { icon: faFileWord, color: "#2980b9" },
    "gdocs": { icon: faFileWord, color: "#2980b9" },
    "gform": { icon: faFile, color: "#8e44ad" },
    "gpres": { icon: faFile, color: "#d35400" },
    "gsheet": { icon: faFileExcel, color: "green" },
    "html": { icon: faFileCode, color: "#e67e22" },
    "image": { icon: faFileImage, color: "#e84393" }, // pink
    "jpg": { icon: faFileImage, color: "#e84393" },
    "jpeg": { icon: faFileImage, color: "#e84393" },
    "gif": { icon: faFileImage, color: "#e84393" },
    "png": { icon: faFileImage, color: "#e84393" },
    "keynote": { icon: faFilePowerpoint, color: "#f39c12" },
    "link": { icon: faFile, color: "#3498db" },
    "mp4": { icon: faVideo, color: "rgb(255, 0, 0)" },
    "overlay": { icon: faFile, color: "#95a5a6" },
    "pack": { icon: faFile, color: "#95a5a6" },
    "pages": { icon: faPager, color: "#2980b9" },
    "pdf": { icon: faFilePdf, color: "#9f0c0c" },
    "ppt": { icon: faFilePowerpoint, color: "#d35400" },
    "pptx": { icon: faFilePowerpoint, color: "#d35400" },
    "psd": { icon: faFileImage, color: "#34495e" },
    "quip_doc": { icon: faFileWord, color: "#2980b9" },
    "quip_sheet": { icon: faFileExcel, color: "green" },
    "quip_slide": { icon: faFilePowerpoint, color: "#d35400" },
    "rtf": { icon: faFile, color: "#7f8c8d" },
    "slide": { icon: faFilePowerpoint, color: "#e67e22" },
    "stypi": { icon: faFile, color: "#95a5a6" },
    "txt": { icon: faFileLines, color: "#7f8c8d" },
    "video": { icon: faVideo, color: "#e74c3c" },
    "visio": { icon: faFile, color: "#2980b9" },
    "webex": { icon: faVideo, color: "#3498db" },
    "word": { icon: faFileWord, color: "#2980b9" },
    "docx": { icon: faFileWord, color: "#2980b9" },
    "doc": { icon: faFileWord, color: "#2980b9" },
    "xlsm": { icon: faFileExcel, color: "green" },
    "xml": { icon: faFileCode, color: "#e67e22" },
    "xlsx": { icon: faFileExcel, color: "green" },
    "xls": { icon: faFileExcel, color: "green" },
    "zip": { icon: faFileZipper, color: "#7f8c8d" },
};
